import { ApiImage } from '../api/image'
import PutImageWithSpecificDisplayLevelAtFirst from './image-sorter/put-image-with-specific-display-level-at-first'
import PutImageWithSpecificImageAppKindAtFirst from './image-sorter/put-image-with-specific-image-app-kind-at-first'
import SortImagesByDisplayLevel from './image-sorter/sort-images-by-display-level'
export default class ImageCollection {
  static create(images: ApiImage[]): ImageCollection {
    return new ImageCollection(images)
  }

  private constructor(private images: ApiImage[]) {}

  sortByDisplayLevel(): ApiImage[] {
    return new SortImagesByDisplayLevel().sort(this.images)
  }

  /**
   * コンタクトレンズ商品リストに表示する画像を決定するためのソートメソッド
   *
   * @param integer|null displayLevelOfImageToDisplay
   * @param string|null imageAppKind
   * @return ApiImage[]
   */
  sortForContactLensItemList(
    displayLevelOfImageToDisplay: number | null,
    imageAppKind: string | null
  ): ApiImage[] {
    const images = this.sortByDisplayLevel()

    if (displayLevelOfImageToDisplay !== null) {
      return new PutImageWithSpecificDisplayLevelAtFirst(displayLevelOfImageToDisplay).sort(images)
    }

    if (imageAppKind !== null) {
      return new PutImageWithSpecificImageAppKindAtFirst(imageAppKind).sort(images)
    }

    return images
  }

  findInstaImage(): ApiImage | null {
    return this.images.find(img => img.isInstaView) || null
  }
}
